import React, { createContext, useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

//path to API call IMPORTANT!
import packageJson from '../../../../package.json'
const { config } = packageJson

const MyContext = createContext()

export const MyProvider = ({ children }) => {
  const [company, setCompany] = useState([])
  const [staff, setStaff] = useState([])
  const [department, setDepartment] = useState([])
  const [division, setDivision] = useState([])
  const [position, setPosition] = useState([])
  const [competency, setCompetency] = useState([])
  const [indicator, setIndicator] = useState([])
  const [training, setTraining] = useState([])
  const [cluster, setCluster] = useState([])
  const [assessment, setAssessment] = useState([])
  const [assessmentResult, setAssessmentResult] = useState(null)
  const [assessmentDraft, setAssessmentDraft] = useState(null)
  const [positionCompetency, setPositionCompetency] = useState([])
  // positionCompetency2 removed - used only positionCompetency
  const [competencyTraining, setCompetencyTraining] = useState([])
  const [staffAssessor, setStaffAssessor] = useState([])
  const [loading, setLoading] = useState({
    company: true,
    staff: true,
    department: true,
    division: true,
    position: true,
    competency: true,
    indicator: true,
    cluster: true,
    training: true,
    assessment: true,
    assessmentResult: true,
    assessmentDraft: true,
    positionCompetency: true,
    competencyTraining: true,
    staffAssessor: true,
  })

  // ...........COMPANY...........
  const fetchCompany = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/company/getallcompany`)
      setCompany(response.data)
    } catch (error) {
      console.error('Error fetching company:', error)
    } finally {
      setLoading((prev) => ({ ...prev, company: false }))
    }
  }, [])

  const updateCompany = useCallback(async (data) => {
    try {
      const response = await axios.put(
        `${config.REACT_APP_API_ENDPOINT}/company/updatecompany/${data.assessmentid}`,
        { assessmentdata: data },
      )
      if (response.data) {
        alert('Assessment updated')
      }
    } catch (error) {
      console.error('Error updating company:', error)
    }
  }, [])

  // ...........STAFF...........
  const fetchStaff = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/employee/getallemployee`)
      setStaff(response.data)
    } catch (error) {
      console.error('Error fetching staff:', error)
    } finally {
      setLoading((prev) => ({ ...prev, staff: false }))
    }
  }, [])

  const createStaff = useCallback(async (employeedata) => {
    try {
      await axios.post(`${config.REACT_APP_API_ENDPOINT}/employee/createemployee`, {
        employeedata: employeedata,
      })
      // NOTE: Consider refetching staff data here to update the list
    } catch (error) {
      console.error('Error creating staff:', error)
    } finally {
      // Re-set loading state only if it was set to true before the try block
    }
  }, [])

  const updateStaff = useCallback(async (employeedata) => {
    try {
      await axios.put(
        `${config.REACT_APP_API_ENDPOINT}/employee/updateemployee/${employeedata.employeeid}`,
        { employeedata: employeedata },
      )
      // NOTE: Consider refetching staff data here to update the list
    } catch (err) {
      console.error('Error updating staff:', err)
    } finally {
      // Re-set loading state only if it was set to true before the try block
    }
  }, [])

  const fetchStaffAssessor = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/assessor/getallassessor`)
      setStaffAssessor(response.data)
    } catch (error) {
      console.error('Error fetching staff assessor:', error)
    } finally {
      setLoading((prev) => ({ ...prev, staffAssessor: false }))
    }
  }, [])

  // ...........POSITION...........
  const fetchPosition = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/job/getalljob`)
      setPosition(response.data)
    } catch (error) {
      console.error('Error fetching position:', error)
    } finally {
      setLoading((prev) => ({ ...prev, position: false }))
    }
  }, [])

  // ...........DEPARTMENT..........
  const fetchDepartment = useCallback(async () => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/department/getalldepartment`,
      )
      setDepartment(response.data)
    } catch (error) {
      console.error('Error fetching department:', error)
    } finally {
      setLoading((prev) => ({ ...prev, department: false }))
    }
  }, [])

  // ...........DIVISION.............
  const fetchDivision = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/division/getalldivision`)
      setDivision(response.data)
    } catch (error) {
      console.error('Error fetching division:', error)
    } finally {
      setLoading((prev) => ({ ...prev, division: false }))
    }
  }, [])

  // ...........COMPETENCY...........
  const fetchCompetency = useCallback(async () => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/competency/getallcompetency`,
      )
      setCompetency(response.data)
    } catch (error) {
      console.error('Error fetching competency:', error)
    } finally {
      setLoading((prev) => ({ ...prev, competency: false }))
    }
  }, [])

  const fetchIndicator = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/indicator/getallindicator`)
      setIndicator(response.data)
    } catch (error) {
      console.error('Error fetching indicator:', error)
    } finally {
      setLoading((prev) => ({ ...prev, indicator: false })) // Corrected to use indicator loading state
    }
  }, [])

  // ...........TRAINING.........
  const fetchTraining = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/training/getalltraining`)
      setTraining(response.data)
    } catch (error) {
      console.error('Error fetching training:', error)
    } finally {
      setLoading((prev) => ({ ...prev, training: false }))
    }
  }, [])

  // ...........CLUSTER.......
  const fetchCluster = useCallback(async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_ENDPOINT}/cluster/getallcluster`)
      setCluster(response.data)
    } catch (error) {
      console.error('Error fetching cluster:', error)
    } finally {
      setLoading((prev) => ({ ...prev, cluster: false }))
    }
  }, [])

  // ...........ASSESSMENT..........
  const fetchAssessment = useCallback(async () => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/assessment/getallassessment`,
      )
      setAssessment(response.data)
    } catch (error) {
      console.error('Error fetching assessment:', error)
    } finally {
      setLoading((prev) => ({ ...prev, assessment: false }))
    }
  }, [])

  // Corrected fetchAssessmentResult with useCallback and removed setTimeout
  const fetchAssessmentResult = useCallback(async (assessmentid) => {
    if (!assessmentid) return // Prevent fetch if no ID is passed
    setLoading((prev) => ({ ...prev, assessmentResult: true }))
    console.log('Data fetching for assessment result...')
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/assessmentresult/getallassessmentresult/${assessmentid}`,
      )

      console.log('Assessment results data are fetched')

      if (response.data) {
        setAssessmentResult(response.data)
      }
    } catch (error) {
      console.error('Error fetching assessment results:', error)
    } finally {
      setLoading((prev) => ({ ...prev, assessmentResult: false }))
    }
  }, [])

  const fetchAssessmentDraft = useCallback(async (assessmentid) => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/assessmentdraft/getallassessmentdraft/${assessmentid}`,
      )
      setAssessmentDraft(response.data)
    } catch (error) {
      console.error('Error fetching assessment draft:', error)
    } finally {
      setLoading((prev) => ({ ...prev, assessmentDraft: false }))
    }
  }, [])

  // ...........MAPPING (POSITION COMPETENCY)..........
  const fetchPositionCompetency = useCallback(async () => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/jobcompetency/getalljobcompetency`,
      )
      setPositionCompetency(response.data) // Removed Object.freeze
    } catch (error) {
      console.error('Error fetching position competency:', error)
    } finally {
      setLoading((prev) => ({ ...prev, positionCompetency: false }))
    }
  }, [])
  // fetchPositionCompetency2 has been removed

  // ...........MAPPING (COMPETENCY TRAINING)..........
  const fetchCompetencyTraining = useCallback(async () => {
    try {
      const response = await axios.get(
        `${config.REACT_APP_API_ENDPOINT}/trainingcompetency/getalltrainingcompetency`,
      )
      setCompetencyTraining(response.data)
    } catch (error) {
      console.error('Error fetching competency training:', error)
    } finally {
      setLoading((prev) => ({ ...prev, competencyTraining: false }))
    }
  }, [])

  // Initial Data Fetch on Mount
  useEffect(() => {
    fetchCompany()
    fetchStaff()
    fetchStaffAssessor()
    fetchPosition()
    fetchDepartment()
    fetchDivision()
    fetchCompetency()
    fetchIndicator()
    fetchCluster()
    fetchAssessment()
    fetchPositionCompetency()
    fetchCompetencyTraining()
    fetchTraining()
  }, [
    fetchCompany,
    fetchStaff,
    fetchStaffAssessor,
    fetchPosition,
    fetchDepartment,
    fetchDivision,
    fetchCompetency,
    fetchIndicator,
    fetchCluster,
    fetchAssessment,
    fetchPositionCompetency,
    fetchCompetencyTraining,
    fetchTraining,
  ]) // Dependencies MUST include all functions to avoid lint warnings and stale closure issues, but useCallback makes them stable.

  return (
    <MyContext.Provider
      value={{
        company,
        staff,
        staffAssessor,
        updateStaff,
        department,
        division,
        position,
        competency,
        indicator,
        cluster,
        assessment,
        training,
        assessmentResult,
        fetchAssessmentResult,
        assessmentDraft,
        fetchAssessmentDraft,
        positionCompetency,
        competencyTraining,
        loading,
      }}
    >
      {children}
    </MyContext.Provider>
  )
}

MyProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MyContext
